import React, { useEffect, useMemo, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import FormikForm from "components/shared/FormikForm";
import { addPermissionApi, updatePermissionApi } from "store/actions";
// import Validation from "views/permissions/Validation"; // adjust path/schema as needed


export default function AddUpdatePermission({
  show,
  handleClose,
  handleConfirm,
  title,
  loading,
  rowData,
}) {
  const dispatch = useDispatch();
  const isUpdateMode = !!rowData;
  const formRef = useRef(null);

  const { permissionMetaLogsList = [] } = useSelector((state) => state.Permission || {});

  const [initialValues, setInitalValues] = useState({
    module: rowData?.module || "",
    action: rowData?.action || "",
    description: rowData?.description || "",
  });
  const [submitLoading, setSubmitLoading] = useState(false); // NEW: own loading state for the API call

  useEffect(() => {
    if (rowData) {
      setInitalValues({
        module: rowData?.module || "",
        action: rowData?.action || "",
        description: rowData?.description || "",
      });
    }
  }, [rowData]);

  const moduleOptions = useMemo(
    () =>
      (permissionMetaLogsList || []).map((item) => ({
        label: item.key,
        value: item.key, // send the key/name directly, NOT item._id
      })),
    [permissionMetaLogsList]
  );

  const InputFields = useMemo(
    () => [
      {
        name: "module",
        type: "select",
        label: "Module",
        placeholder: "Select module...",
        options: moduleOptions,
      },
      {
        name: "action",
        type: "select",
        label: "Action",
        placeholder: "Select action...",
        options: [
          { label: "View", value: "view" },
          { label: "Add", value: "add" },
          { label: "Edit", value: "edit" },
          { label: "Delete", value: "delete" },
          { label: "Export", value: "exports" },
        ],
      },
      {
        name: "description",
        type: "text",
        label: "Description",
        placeholder: "Description...",
      },
    ],
    [moduleOptions]
  );

  const handleValuesChange = (newValues) => {
    const unchanged =
      newValues.module === initialValues.module &&
      newValues.action === initialValues.action &&
      newValues.description === initialValues.description;

    if (unchanged) return;
    setInitalValues({ ...newValues });
  };

  // NEW: builds the payload and calls the API directly from here (same as AddUpdateRole)
  const handleSubmit = (values) => {
    const normalized = {
      module: values.module,
      action: values.action,
      description: values.description,
    };

    const payload = isUpdateMode
      ? { _id: rowData._id, ...normalized }
      : { ...normalized };

    const action = isUpdateMode ? updatePermissionApi : addPermissionApi;

    setSubmitLoading(true);

    dispatch(
      action({
        data: payload,
        callBack: (err, response) => {
          setSubmitLoading(false);
          if (err) return;
          handleConfirm(response); // parent just closes modal + refreshes list
        },
      }),
    );
  };

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} centered size="md">
      <Modal.Header className="py-3 text-dark" closeButton>
        <Modal.Title className="fw-bold text-dark">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormikForm
          initialValues={initialValues}
          onSubmit={handleSubmit}
          loading={loading || submitLoading}
          inputFields={InputFields}
          buttonText={"Submit"}
          col={12}
          ref={formRef}
          onValuesChange={handleValuesChange}
        />
      </Modal.Body>
    </Modal>
  );
}